import baseUrl from '../utils/baseUrl'
import axios from './api'

const getAllMechanics = async (page, perPage, sortBy, sortDirection, searchText) =>
    await axios
        .get(baseUrl + `/mechanics/admin/search`, {
            params: {
                page,
                size: perPage,
                sort: `${sortBy},${sortDirection}`,
                searchText
            }
        })
        .then((response) => response.data)

const saveMechanic = async (body) =>
    await axios.post(baseUrl + '/mechanics/save', body).then((response) => response.data)

const updateMechanic = async (id, body) =>
    await axios.put(baseUrl + `/mechanics/${id}`, body).then((response) => response.data)

const getAllPriceImages = async () =>
    await axios.get(baseUrl + `/establishment-price-image/all`).then((response) => response.data)

const savePriceImage = async (establishmentId, body) =>
    await axios
        .post(baseUrl + `/mechanics/prices/save-and-remove-image/${establishmentId}`, body)
        .then((response) => response.data)

const removePriceImageByEstablishmentId = async (establishmentId) =>
    await axios
        .delete(baseUrl + `/establishment-price-image/remove-by-establishment/${establishmentId}`)
        .then((response) => response.data)

const saveMechanicLogo = async (mechanicId, file) => {
    const formData = new FormData()
    formData.append('file', file)

    return await axios
        .post(baseUrl + `/mechanics/logo/save/${mechanicId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => response.data)
}

export {
    getAllMechanics,
    saveMechanic,
    updateMechanic,
    getAllPriceImages,
    savePriceImage,
    saveMechanicLogo,
    removePriceImageByEstablishmentId
}
